import { FIREBASE_RECAPTCH_APIKEY } from '@portal/config/env';

/**
 * Executes reCAPTCHA Enterprise and returns a token for server-side verification.
 * Uses the same site key as Firebase App Check (ReCAPTCHA Enterprise).
 */
export const executeRecaptcha = async (
  action: string
): Promise<string | null> => {
  const siteKey = FIREBASE_RECAPTCH_APIKEY;
  if (!siteKey) return null;

  return new Promise((resolve) => {
    const recaptcha = window.grecaptcha?.enterprise;
    if (!recaptcha) {
      resolve(null);
      return;
    }

    recaptcha.ready(async () => {
      try {
        const token = await recaptcha.execute(siteKey, { action });
        resolve(token);
      } catch {
        resolve(null);
      }
    });
  });
};
